import { ESymbolCategory } from '@aqx-core/common/api/market';
import { EDateRangeOption, ESortOption, IAssetsFilterValues } from '@aqx-core/common/services/assets-filter/types';

export const DefaultFilterSortValue: IAssetsFilterValues = {
  sortBy: ESortOption.LATEST,
  assetTypes: [ESymbolCategory.ALL],
  currentAssetType: ESymbolCategory.ALL,
  dateRange: {
    value: EDateRangeOption.ALL
  },
  orderType: 'ALL'
};
